module.exports = __webpack_public_path__ + "static/media/finacials-white.7d7cc05f.svg";